import { Form } from 'formik'
import IconConfirm from '/public/icons/icon-book-confirm.svg'
import Radio from '../../../../../../../../../elements/form/Radio'
import { useEffect, useState } from 'react'
import capitalize from 'lodash-es/capitalize'
import Button from '../../../../../../../../../elements/Button'
import CustomField from '../../../../../../../../../elements/form/CustomField'
import styles from './styles.module.scss'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useSearchContext } from '/providers/SearchContext'

const ThankYou = ({ setFieldValue, translations }) => {
  const router = useRouter()
  const [transport, setTransport] = useState('')
  const [details, setDetails] = useState('')
  const [pets, setPets] = useState('')
  const [arrangements, setArrangements] = useState('')
  const [grocery, setGrocery] = useState('')
  const [phone, setPhone] = useState('')
  const { setReset, setReserved } = useSearchContext()

  useEffect(() => {
    setReset(true)
    setReserved(true)
    setTimeout(() => {
      setReset(false)
      setReserved(false)
    }, 100)
  }, [])

  const checkboxesUnknown = [
    translations?.yes[router.locale],
    translations?.no[router.locale],
    translations?.unknown[router.locale]
  ]

  const checkboxes = [
    translations?.yes[router.locale],
    translations?.no[router.locale]
  ]

  return (
    <Form className={classNames(styles.form, styles.thanks)}>
      <div className={styles.form__intro}>
        <IconConfirm />

        <h2 className={styles.form__title}>
          {translations?.title[router.locale]}
        </h2>

        <p>{translations?.subtitle[router.locale]}</p>
      </div>

      <label className={styles.form__label}>
        {translations?.phoneNumber[router.locale]}
      </label>

      <CustomField
        name="phone"
        optional
        onChange={(e) => {
          setFieldValue('phone', e.target.value.replace(/[^0-9+()]/g, ''))
          setPhone(e.target.value.replace(/[^0-9+()]/g, ''))
        }}
        value={phone}
        type="tel"
        variant={['full-width', 'white']}
      />

      <label className={styles.form__label}>
        {translations?.rentCar[router.locale]}
      </label>

      {checkboxes.map((item, index) => (
        <Radio
          variant={['white']}
          key={`car-${index}`}
          name="car"
          checkbox
          value={item}
          label={capitalize(item)}
          checked={transport === item}
          onChange={(e) => {
            setTransport(e.target.value)
            setFieldValue('car', e.target.value)
          }}
        />
      ))}

      <p className={styles.form__additional}>
        {translations?.rentCarNote[router.locale]}
      </p>

      <label className={styles.form__label}>
        {translations?.transport[router.locale]}
      </label>

      {checkboxes.map((item, index) => (
        <Radio
          variant={['white']}
          key={`transport-${index}`}
          name="transport"
          checkbox
          value={item}
          label={capitalize(item)}
          checked={pets === item}
          onChange={(e) => {
            setPets(e.target.value)
            setFieldValue('transport', e.target.value)
          }}
        />
      ))}
      <p className={styles.form__additional}>
        {translations?.transportNote[router.locale]}
      </p>

      <label className={styles.form__label}>
        {translations?.assistance[router.locale]}
      </label>

      {checkboxesUnknown.map((item, index) => (
        <Radio
          variant={['white']}
          key={`assistance-${index}`}
          name="assistance"
          checkbox
          value={item}
          label={capitalize(item)}
          checked={arrangements === item}
          onChange={(e) => {
            setArrangements(e.target.value)
            setFieldValue('assistance', e.target.value)
          }}
        />
      ))}
      <p className={styles.form__additional}>
        {translations?.assistanceNote[router.locale]}
      </p>

      <label className={styles.form__label}>
        {translations?.food[router.locale]}
      </label>

      {checkboxesUnknown.map((item, index) => (
        <Radio
          variant={['white']}
          key={`food-${index}`}
          name="food"
          checkbox
          value={item}
          label={capitalize(item)}
          checked={grocery === item}
          onChange={(e) => {
            setGrocery(e.target.value)
            setFieldValue('food', e.target.value)
          }}
        />
      ))}

      <label className={styles.form__label}>
        {translations?.foodNote[router.locale]}
      </label>

      {checkboxesUnknown.map((item, index) => (
        <Radio
          variant={['white']}
          key={`reservation-${index}`}
          name="reservation"
          checkbox
          value={item}
          label={capitalize(item)}
          checked={details === item}
          onChange={(e) => {
            setDetails(e.target.value)
            setFieldValue('reservation', e.target.value)
          }}
        />
      ))}

      <Button
        arrow={false}
        className={styles.form__submit}
        variant={['color-accent']}
      >
        {translations?.submit[router.locale]}
      </Button>
    </Form>
  )
}

export default ThankYou
